/* eslint-disable no-shadow */
/**
 * Return the array of all users
 * @param {State} state vuex state
 * @returns {Object} object describing current user
 */
export const user = ({ user }) => user
// export const isConnected = ({ isConnected }) => isConnected
export const error = ({ error }) => error
